import { render, staticRenderFns } from "./PeiTabIVStudentServices.vue?vue&type=template&id=0f5cb73c&"
import script from "./PeiTabIVStudentServices.vue?vue&type=script&lang=js&"
export * from "./PeiTabIVStudentServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports